
import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Modal,
  Tooltip,
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
} from "@mui/material";
import {
  viewtaskdelete,
  resetDeletedTask,
  viewsubtaskdelete,
  resetDeletedSubTask,
} from "../../store/grupo.actions";
import IconButton from "@mui/material/IconButton";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import { FaLayerGroup } from "react-icons/fa";
import { AiFillFileText } from "react-icons/ai";
import MoveUpIcon from '@mui/icons-material/MoveUp';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import NotesIcon from '@mui/icons-material/Notes';
import GridViewIcon from '@mui/icons-material/GridView';


const PapeleraModal = ({ open, handleClose }) => {
  const [view, setView] = useState(null); // Inicialmente sin selección
  const [actividadesEliminadas, setActividadesEliminadas] = useState([]);
  const [subActividadesEliminadas, setSubActividadesEliminadas] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(4);
  const currentBoard = useSelector((storeState) => storeState.boardModule.currentBoard);
  const [isTyping, setIsTyping] = useState(false);
const handleMouseEnter = () => setIsTyping(true);  // Cuando el ratón pasa sobre la celda
const handleMouseLeave = () => setIsTyping(false); // Cuando el ratón sale de la celda

 

  const handleLoadData = async (newView) => {
    try {
      setView(newView);

      if (newView === "actividades") {
        const response = await viewtaskdelete(currentBoard.id_tablero);
        setActividadesEliminadas(response.actividades);
      } else if (newView === "sub_actividades") {
        const response = await viewsubtaskdelete(currentBoard.id_tablero);
        setSubActividadesEliminadas(response.subactividades);
      }
    } catch (error) {
      console.error("Error al cargar datos:", error);
    }
  };

  const handleRestore = (id, type) => {
    if (type === "actividad") {
      const actividadRestaurada = actividadesEliminadas.find(
        (actividad) => actividad.id_actividad === id
      );
      if (actividadRestaurada) {
        const success = resetDeletedTask(actividadRestaurada, actividadRestaurada.fk_grupo_id);
        if (success) {
          setActividadesEliminadas(
            actividadesEliminadas.filter((actividad) => actividad.id_actividad !== id)
          );
        }
      }
    } else if (type === "subactividad") {
      const subactividadRestaurada = subActividadesEliminadas.find(
        (subactividad) => subactividad.id_subactividad === id
      );
      if (subactividadRestaurada) {
        const success = resetDeletedSubTask(subactividadRestaurada);
        if (success) {
          setSubActividadesEliminadas(
            subActividadesEliminadas.filter((subactividad) => subactividad.id_subactividad !== id)
          );
        }
      }
    }
  };

  const renderTable = () => {
    const data = view === "actividades" ? actividadesEliminadas : subActividadesEliminadas;

    function formatDate(dateString) {
      const date = new Date(dateString);
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true, // Activar formato de 12 horas con AM/PM
      };
      return date.toLocaleString("es-ES", options).replace(',', ''); // Quitar la coma si aparece
    }
    

    return (
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
            <TableCell sx={{ width: 120, textAlign: "center", fontWeight: "bold" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center",}}>
              <GridViewIcon style={{ marginRight: "5px" }} /> Grupo
            </div>
            </TableCell>
            <TableCell sx={{ width: 400, textAlign: "center", fontWeight: "bold" }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center",}}>
              <BookmarkBorderIcon style={{ marginRight: "5px" }} /> Descripción
            </div>
          </TableCell>
          <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>      
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center",}}>
            <CalendarMonthIcon style={{ marginRight: "5px" }} /> Fecha de Eliminación
            </div>
          </TableCell>
            <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center",}}>
            <NotesIcon style={{ marginRight: "5px" }} /> Acción
            </div>
            </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((item, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                >
                <TableCell sx={{ textAlign: "center",maxWidth: 200, overflow: "hidden", whiteSpace: "nowrap" }}>
                    {/* Tooltip que muestra el contenido completo al pasar el ratón */}
                    <Tooltip title={item.nombre_grupo} arrow placement="top">
                    <div> {item.nombre_grupo}</div>
                  </Tooltip>
             
                  
                  </TableCell>
                 <TableCell sx={{ textAlign: "left", maxWidth: 350, overflow: "hidden", whiteSpace: "nowrap" }}>
                  {/* Tooltip que muestra el contenido completo al pasar el ratón */}
                  <Tooltip title={item.descripcion} arrow placement="top">
                    <div>{item.descripcion}</div>
                  </Tooltip>
                </TableCell>

                  <TableCell sx={{ textAlign: "center",maxWidth: 200 }}>{formatDate(item.updated_at)}</TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    <Tooltip
                      title={view === "actividades" ? "Restablecer Actividad" : "Restablecer Subactividad"}
                      arrow
                    >
                      <IconButton
                        color="primary"
                        onClick={() =>
                          handleRestore(
                            item.id_actividad || item.id_subactividad,
                            view === "actividades" ? "actividad" : "subactividad"
                          )
                        }
                      >
                        <DeleteSweepIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[4, 10, 25]}
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(e, newPage) => setPage(newPage)}
          onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
        />
      </TableContainer>
    );
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "70%",
          
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" mb={2} textAlign="center">
          Papelera de FRIDAY
        </Typography>

        <Box display="flex" justifyContent="center" gap={2} mb={3}>
          <Button
            variant={view === "actividades" ? "contained" : "outlined"}
            onClick={() => handleLoadData("actividades")}
          >
             <MoveUpIcon style={{ marginRight: "8px" }} /> {/* Espacio entre ícono y texto */}
             Actividades Eliminadas
          </Button>
          <Button
            variant={view === "sub_actividades" ? "contained" : "outlined"}
            onClick={() => handleLoadData("sub_actividades")}
          >
             <MoveDownIcon style={{ marginRight: "8px" }} /> {/* Espacio entre ícono y texto */}
            Sub-Actividades Eliminadas
          </Button>
        </Box>

        {view && renderTable()}
      </Box>
    </Modal>
  );
};

export default PapeleraModal;

